import { Box } from 'features/knowledgeDocumentViewer/components/viewer/shared/types'
import { ActionMode } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import type {
  BoundingBoxJsonItem,
  NormalizedBBox,
} from 'features/knowledgeDocumentViewer/types/ocrViewer'

export const unionNormalizedBBoxes = (
  boxes: NormalizedBBox[]
): NormalizedBBox => {
  const minLeft = Math.min(...boxes.map((b) => b.left))
  const minTop = Math.min(...boxes.map((b) => b.top))
  const maxRight = Math.max(...boxes.map((b) => b.left + b.width))
  const maxBottom = Math.max(...boxes.map((b) => b.top + b.height))

  return {
    top: minTop,
    left: minLeft,
    width: maxRight - minLeft,
    height: maxBottom - minTop,
  }
}

export const calculateGroupBoundingBoxes = (
  boxes: BoundingBoxJsonItem[]
): NormalizedBBox => unionNormalizedBBoxes(boxes.map((b) => b.bounding_box))

export const shouldBoxBeDisabled = (box: Box, actionMode: ActionMode) => {
  return (
    (actionMode === ActionMode.Assign && box.confirmed) ||
    (actionMode === ActionMode.Remove && !box.confirmed) ||
    (actionMode === ActionMode.Group && box.confirmed) ||
    (actionMode === ActionMode.Split &&
      (box.confirmed || box.groupId === undefined))
  )
}
